import { Component } from '@angular/core';
import { PimProductComponent } from 'gung-standard';

@Component({
    selector: 'car-liner-pim-product',
    templateUrl: './car-liner-pim-product.component.html',
    styleUrls: ['./car-liner-pim-product.component.scss'],
    standalone: false
})
export class CarLinerPimProductComponent extends PimProductComponent {}
